<template>
  <div class="container">
    <app-header title="开具发票"/>
    <div class="main">
      <div class="title">
        <span>发票类型</span>
        <span class="type">（线下支付只可开具专用发票）</span>
      </div>
      <div class="tip">请谨慎选择发票类型，发票开出后，无法更换</div>
      <div class="tabs">
        <div
        class="item"
        @click="params.type = 1"
        :style="params.type === 1?'background: #FEEAEE;box-sizing: border-box;border: 1px solid #E10F02':''"
        style="position: relative;">
          <div>普通发票</div>
          <div>（增值税）</div>
          <div
            style="width: 65px;height: 24px;position: absolute;top: -10px;right: -40px;line-height: 24px;
          border-radius: 8px 8px 8px 0px;z-index: 1;background: #E10F02;color: #FFFFFF;font-size: 10px;text-align: center;"> 不可抵税 </div>
        </div>
        <div class="item" @click="params.type = 0" :style="params.type === 0?'background: #FEEAEE;box-sizing: border-box;border: 1px solid #E10F02':''">
          <div>专用发票</div>
          <div>（增值税）</div>
        </div>
        <div class="item"  @click="params.type = 2" :style="params.type === 2?'background: #FEEAEE;box-sizing: border-box;border: 1px solid #E10F02':''">
          <div>不需要发票</div>
        </div>
      </div>
      <!--普票-->
      <div class="method" v-if="params.type==1">
        <van-radio-group v-model="params.opentype" direction="horizontal">
          <van-radio :name="0" checked-color="#FE003B">纸质发票</van-radio>
          <van-radio :name="1" checked-color="#FE003B" v-if="electronicsTicket">电子发票</van-radio>
        </van-radio-group>
      </div>
      <!--专票-->
      <div class="method" v-if="params.type==0">
        <van-radio-group v-model="params.opentype" direction="horizontal">
          <van-radio :name="0" checked-color="#FE003B">累计开</van-radio>
          <van-radio :name="1" checked-color="#FE003B">随货发 <span style="color: #E10F02;font-size: 11px;">(满500元可以开票)</span></van-radio>
        </van-radio-group>
      </div>
      <div class="title">
        发票信息
      </div>
      <div class="form">
        <div class="form-group" v-if="this.params.type!=2">
          <div class="name">
            <img src="@/assets/star.png" alt="必填" width="10" height="10" class="star">
            <span>发票抬头</span>
          </div>
          <input type="text" v-model="params.companyName" class="input">
        </div>
        <div class="form-group" v-if="this.params.type!=2">
          <div class="name">
            <img src="@/assets/star.png" alt="必填" width="10" height="10" class="star">
            <span>税号</span>
          </div>
          <input type="text" v-model="params.code" class="input">
        </div>
        <div class="form-group" v-if="this.params.type!=2">
          <div class="name">
            <img src="@/assets/star.png" alt="必填" width="10" height="10" class="star">
            <span>地址</span>
          </div>
          <input type="text" v-model="params.companyAddress" class="input">
        </div>
        <div class="form-group" v-if="this.params.type!=2">
          <div class="name">
            <img src="@/assets/star.png" alt="必填" width="10" height="10" class="star">
            <span>联系电话</span>
          </div>
          <input type="text" v-model="params.tel" class="input">
        </div>
        <div class="form-group" v-if="this.params.type!=2">
          <div class="name">
            <img src="@/assets/star.png" alt="必填" width="10" height="10" class="star">
            <span>开户行</span>
          </div>
          <input type="text" v-model="params.backName" class="input">
        </div>
        <div class="form-group" v-if="this.params.type!=2">
          <div class="name">
            <img src="@/assets/star.png" alt="必填" width="10" height="10" class="star">
            <span>银行账户</span>
          </div>
          <input type="text" v-model="params.backAcount" class="input">
        </div>
        <div class="form-group" v-if="this.params.type!=2">
          <div class="name">
            <img src="@/assets/star.png" alt="必填" width="10" height="10" class="star">
            <span>收票人姓名</span>
          </div>
          <input type="text" v-model="params.receiveName" class="input">
        </div>
        <div class="form-group" v-if="this.params.type!=2">
          <div class="name">
            <img src="@/assets/star.png" alt="必填" width="10" height="10" class="star">
            <span>收票人联系方式</span>
          </div>
          <input type="text" v-model="params.receiveTel" class="input">
        </div>
        <div class="form-group" v-if="this.params.type!=2">
          <div class="name">
            <img src="@/assets/star.png" alt="必填" width="10" height="10" class="star">
            <span>收票人地址</span>
          </div>
          <input type="text" v-model="params.receiveAddress" class="input">
        </div>
        <div class="form-group" style="margin-top: 10px;line-height: 20px">
          发票内容说明：发票的内容和所购买的产品可能是同类产品内容，但如果该产品没有进项票的话，可以接受其他同类产品的发票内容。需要开原型号的发票的客户，请与客服联系。
        </div>
      </div>
      <div class="submit" @click="_saveUserTicket">确定</div>
    </div>
  </div>
</template>

<script>
import { getSysSetting } from '@/api/system'
import { saveUserTicket,getUserTicket,queryShopServiceChargeList} from '@/api/ticket/user.js'
export default {
  name: 'Index',
  data() {
    return {
      //电子发票是否开启
      electronicsTicket: 0,
      params: {
        opentype: 0,
        type: 1,
        companyName: '',
        code: '',
        companyAddress: '',
        tel: '',
        backName: '',
        backAcount: '',
        serviceCharge: '',
        coid:'',
        receiveName:'',
        receiveTel:'',
        receiveAddress:'',
      }
    }
  },
  created(){
    this._queryShopServiceChargeList()
    if (this.$route.query.id){
      this.getUserTicket()
    }
    this.getSysSetting()
  },
  methods: {
    //电子发票是否开启
    getSysSetting(){
      getSysSetting({}).then(res=>{
        if (res.success){
          this.electronicsTicket = res.data.electronicsTicket
        }
      })
    },
    getUserTicket(){
      getUserTicket({id: this.$route.query.id}).then(res=>{
        if (res.success){
          this.params = res.data
        }
      })
    },
    // 新增发票
    _saveUserTicket() {
      if (this.params.type == 2) {
        this.$router.go(-1)
        return
      }
      if (this.params.companyName == '') {
        this.$toast.fail('发票抬头不能为空')
        return
      }

      if (this.params.code == '') {
        this.$toast.fail('税号不能为空')
        return
      }

      if (this.params.companyAddress == '') {
        this.$toast.fail('地址不能为空')
        return
      }

      if (this.params.tel == '') {
        this.$toast.fail('联系电话不能为空')
        return
      }

      if (this.params.backName == '') {
        this.$toast.fail('开户行不能为空')
        return
      }

      if (this.params.backAcount == '') {
        this.$toast.fail('银行账户不能为空')
        return
      }

      if (this.params.receiveName == '') {
        this.$toast.fail('收票人姓名不能为空')
        return
      }

      if (this.params.receiveTel == '') {
        this.$toast.fail('收票人电话不能为空')
        return
      }

      if (this.params.receiveAddress == '') {
        this.$toast.fail('收票人地址不能为空')
        return
      }
      let user = JSON.parse(localStorage.getItem("userInfo"));
      if (!user){
        this.$toast.fail('用户不存在')
        return
      }

      const params = {
        ...this.params,
        uid: user.id
      }
      saveUserTicket(params).then((res) => {
        if ( res.success ) {
          this.$router.go(-1)
        }
      })
    },
    _queryShopServiceChargeList(){
      queryShopServiceChargeList({}).then((res)=>{
        if(res.success){
          this.params.serviceCharge = res.data[0].money
          this.params.coid = res.data[0].id
        }
      })
    },
    onNavigate() {
      this.$router.push({
        path: '/ticket/list'
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    .main{
      padding: 6px 12px 12px 12px;
      .title{
        height:22px;
        font-size:16px;
        font-weight:bold;
        line-height:20px;
        color:#333333;
        .type{
          color: #FE003B;
          font-size:14px;
          font-weight:400;
        }
      }
      .tip{
        height:18px;
        font-size:13px;
        font-weight:400;
        line-height:18px;
        color:rgba(136,137,136,1);
      }
      .tabs{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin-top: 15px;
        .item{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width:97px;
          height:63px;
          background:rgba(243,243,243,1);
          border:1px solid rgba(243,243,243,1);
          opacity:1;
          border-radius:4px;
        }
      }
      .method{
        margin: 20px 0;
      }
      .form{
        .form-group{
          .star{
            margin: 0 10px;
          }
          .name{
            height:22px;
            font-size:16px;
            font-weight:400;
            line-height:21px;
            color:rgba(153,153,153,1);
            margin-top: 8px;
          }
          .input{
            width: 90%;
            /*height:20px;*/
            border:1px solid rgba(243,243,243,1);
            border-radius:4px;
            padding: 10px;
            font-size:16px;
            font-weight:400;
            line-height:21px;
            color:rgba(199,199,199,1);
            margin-top: 8px;
          }
        }
      }
      .submit{
        height:40px;
        background:linear-gradient(0deg,rgba(244,4,66,1) 0%,rgba(226,23,75,0.73) 100%);
        border-radius:4px;
        line-height: 40px;
        margin-top: 18px;
        text-align: center;
        color: #ffffff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ticket/index.vue